import { Message } from 'element-ui'
const DmMessage = Message
export default DmMessage

